import { httpClient } from '@/core/api/http-client'
import { env } from '@/core/config/env'
import type { AuthSession, AuthUser, LoginResult } from '@/domain/entities/auth.entity'
import type { AuthRepository } from '@/domain/repositories/auth.repository'
import { unwrap } from '@/infrastructure/shared/unwrap'
import type { LoginResponseDto, MeResponseDto, SelectTenantResponseDto } from './auth.dto'
import { authMapper } from './auth.mapper'

/**
 * Adapter HTTP untuk autentikasi ke Go BE (Gin).
 * Endpoint mengikuti README: /auth/login, /auth/select-tenant, /me, /auth/logout.
 */
export class AuthHttpRepository implements AuthRepository {
  async login(username: string, password: string): Promise<LoginResult> {
    const raw = await httpClient.post<unknown>(
      '/auth/login',
      { username, password, client_type: env.clientType },
      { auth: false },
    )
    return authMapper.toLoginResult(unwrap<LoginResponseDto>(raw))
  }

  async selectTenant(loginToken: string, tenantId: string): Promise<AuthSession> {
    const raw = await httpClient.post<unknown>(
      '/auth/select-tenant',
      { tenant_id: tenantId, client_type: env.clientType },
      { auth: false, authorization: `Bearer ${loginToken}` },
    )
    return authMapper.toSession(unwrap<SelectTenantResponseDto>(raw))
  }

  async me(): Promise<AuthUser> {
    const raw = await httpClient.get<unknown>('/me')
    return authMapper.toUser(unwrap<MeResponseDto>(raw))
  }

  async logout(refreshToken?: string): Promise<void> {
    await httpClient.post('/auth/logout', { refresh_token: refreshToken ?? '' }, { auth: false })
  }
}
